// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-xl[data-v-e4bb6158]{max-width:524px}@media(max-width: 1199.98px){.explore-img[data-v-e4bb6158]{width:555px}}.explore-item-text[data-v-e4bb6158]{max-width:445px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
